import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'address': 'String!',
}

export default gql(`
	mutation address_validate( ${ HelperGraphql.createFields( fields ) } ) {
	    address_validate( ${ HelperGraphql.createVariables( fields ) } ) {
	        is_valid
	    }
	}
`);

